import { EngagementMetricsKpiTile } from './EngagementMetricsKpiTile';
import type { EngagementMetricsKpis } from '../../../types/engagement-metrics.types';

type EngagementMetricsKpiTilesProps = {
  kpis: EngagementMetricsKpis;
};

const DOT_COLORS = {
  total: '#15543e',
  billable: '#2c6a4a',
  nonBillable: '#7f8a83',
  providers: '#2c5c47',
  dormant: '#bf8a2e',
};

export const EngagementMetricsKpiTiles = ({ kpis }: EngagementMetricsKpiTilesProps) => {
  return (
    <div
      className="grid gap-3.5"
      style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}
      data-testid="engagement-metrics-kpi-tiles"
    >
      <EngagementMetricsKpiTile
        label="Total engagements"
        value={kpis.totalEngagements.toLocaleString('en-US')}
        dotColor={DOT_COLORS.total}
      />
      <EngagementMetricsKpiTile
        label="Billable engagements"
        value={kpis.billableEngagements.toLocaleString('en-US')}
        caption={`${kpis.billablePercent}% of total · chargeable`}
        dotColor={DOT_COLORS.billable}
      />
      <EngagementMetricsKpiTile
        label="Non-billable"
        value={kpis.nonBillableEngagements.toLocaleString('en-US')}
        caption="Networking, continuations, views, SP-outbound messages"
        dotColor={DOT_COLORS.nonBillable}
      />
      <EngagementMetricsKpiTile
        label="Providers engaged"
        value={kpis.providersEngaged.toLocaleString('en-US')}
        caption="Unique providers in period"
        dotColor={DOT_COLORS.providers}
      />
      <EngagementMetricsKpiTile
        label="Dormant providers"
        value={kpis.dormantProviders.toLocaleString('en-US')}
        caption="No engagement in 30+ days"
        dotColor={DOT_COLORS.dormant}
      />
    </div>
  );
};
